
/**
 * 추가 메타데이터
 */
export type UploadMedia201Metadata = { [key: string]: unknown };
